import { Col, Row } from "react-bootstrap";
import { Block } from "../../../hoc/Block";
import { InputField } from "../../../components/controls/InputField/InputField";
import React from "react";

export const KpiSettings = (props) => {
  console.log("kpi settings data: ", props.data)
  return (
    <div>
      <p className="text-start fw-bold mt-3 mb-0">KPI Settings</p>
      <div className={` $"hr" mb-3`}></div>
      <Block disabled={props.disabled}>
        <Row>
          {props.data.length === 0 && <p>No KPI settings available...</p>} 
          {props.data.length > 0 && props.data.map((item, index) =>
              <Col xs={4} key={index}>
                <div onChange={props.onChange}>
                    <input id={"kpi-" + item.id} name={"kpi-" + item.id} value={item.id} checked={item.checked} type="checkbox" />
                    <label htmlFor={"kpi-" + item.id} className="fw-bold ms-2">KPI {index+1}</label>
                </div>
                <label>{item.title}</label>
                <div className="mt-2">
                  <label className="fst-italic">KPI {index+1} Weight (%)</label>
                  <InputField
                      className="ms-2"
                      type="number"
                      fieldtype="number"
                      name={"kpiweight-" + (index + 1)}
                      id={"kpiweight-" + (index + 1)}
                  />
                </div>
              </Col>
          )}
          {/* {props.isEditChecklist && props.data.length > 0 && props.data.map((item, index) =>
            <Col xs={4} key={index}>
              <div onChange={props.onChange}>
                  <input id={"kpi-" + item.id} name={"kpi-" + item.id} value={item.id} defaultChecked={item.checked ? true : false} type="checkbox" />
                  <label htmlFor={"kpi-" + item.id} className="fw-bold ms-2">KPI {item.id}</label>
              </div>
              <label>{item.title}</label>
              <div className="mt-2">
                <label className="fst-italic">KPI {item.id} Weight (%)</label>
                <InputField
                    className="ms-2"
                    type="number"
                    fieldtype="number"
                    name={"kpiweight-" + (item.id)}
                    id={"kpiweight-" + (item.id)}
                    // value={item.weight}
                    // placeholder={item.weight}
                />
              </div>
            </Col>
          )} */}
        </Row>
      </Block>
    </div>
  );
};
